import { Component, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CommonModule } from '@angular/common';
import { GatewayCustomer } from '../../models/GatewayCustomer';
import { getAllCustomers } from '../../state/customer/customer.actions';
import { selectAllCustomers } from '../../state/customer/customer.selector';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { Location } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { LoadingService } from '../../services/LoadingService';
import { PageHeaderComponent } from '../page-header/page-header.component';

@Component({
  selector: 'app-customer-search',
  templateUrl: './customer-search.component.html',
  styleUrl: './customer-search.component.css',
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    RouterModule,
    MatIconModule,
    MatButtonModule,
    PageHeaderComponent
  ]
})
export class CustomerSearchComponent implements OnInit {
  displayedColumns: string[] = ['customerNo', 'companyShortName', 'mail', 'details'];
  dataSource = new MatTableDataSource<GatewayCustomer>([]);
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private store: Store, private location: Location, private loading: LoadingService) {}

  ngOnInit(): void {
    this.loading.start('route');
    this.store.dispatch(getAllCustomers());
    this.store.select(selectAllCustomers).subscribe(customers => {
      this.dataSource.data = customers ?? [];
      if (this.paginator) {
        this.dataSource.paginator = this.paginator;
      }
      // Stop loading after data is received
      if (customers && customers.length >= 0) {
        this.loading.end('route');
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filterPredicate = (data: GatewayCustomer, filter: string) => {
      return (
        data.customerNo.toString().toLowerCase().includes(filter) ||
        data.companyShortName.toLowerCase().includes(filter) ||
        data.mail.toLowerCase().includes(filter)
      );
    };
    this.dataSource.filter = filterValue;
  }

  back() {
    this.location.back();
  }
}
